import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CertificatesPrivateService, FeedMessageService, showSuccess } from '@services/index.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmCancelComponent } from '@shared/index.shared';
import { ErrorCode, CertificateChangePinRequest, CertificateChangePinResponse, Response, } from '@models/index.model';
import { finalize, Observable, take, tap } from 'rxjs';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-private-cert-edit-pin',
    templateUrl: './dialog-private-cert-edit-pin.component.html',
    styles: [],
    standalone: false
})
export class DialogPrivateCertEditPinComponent implements OnInit {
  public isMobile: boolean;
  tooltipTitle: any;
  sendingInfo: boolean = false;

  dataCurrentPin: string = '';
  dataNewPin: string = '';
  dataRepeatNewPin: string = '';

  hidePinCurrent: boolean = true;
  hidePinNew: boolean = true;
  hidePinRepeat: boolean = true;

  _changePin: any;
  certificateChangePinRequest: CertificateChangePinRequest;

  constructor(
    public dialogRef: MatDialogRef<DialogPrivateCertEditPinComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    public translate: TranslateService,
    private _notify: FeedMessageService,
    private _privCertsServ: CertificatesPrivateService
  ) {
    this.isMobile = environment.platform === 'mobile';
    translate.get(['GLOBAL.TOOLTIP']).subscribe(res => {
      this.tooltipTitle = res['GLOBAL.TOOLTIP'];
    });
  }

  ngOnInit() {
  }

  sendPinChange() {
    if (this.dataNewPin === this.dataRepeatNewPin) {
      this.changePin().subscribe();
    }
  }

  changePin(): Observable<Response<CertificateChangePinResponse>> {
    this.sendingInfo = true;
    this.certificateChangePinRequest = {
      personalCertificateId: this.data.id,
      currentPIN: this.dataCurrentPin,
      newPIN: this.dataNewPin,
    }
    return this._privCertsServ.changePinPersonalCertificate(this.certificateChangePinRequest).pipe(
      take(1),
      tap((res: Response<CertificateChangePinResponse>) => {
        this._changePin = res;
        if (this._changePin.errorCode === ErrorCode.OK) {
          this._notify.feedBackResult(this._changePin.messageType, this._changePin.message, showSuccess);
          this.dialogRef.close(true);
        }
      }),
      finalize(() => {
        this.cleanPin();
        this.sendingInfo = false;
      })
    );
  }

  cleanPin() {
    this.dataCurrentPin = '';
    this.dataNewPin = '';
    this.dataRepeatNewPin = '';
  }

  cancelChanges() {
    const dialogRef = this.dialog.open(DialogConfirmCancelComponent, {
      width: '400px',
      data: {}
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.onNoClick();
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
